<template>
  <div class="time-range-picker-wrapper">
    <div class="time-range-picker">
      <el-time-select
        v-model="inbegin"
        :placeholder="$l('form_placeholder_meetingBeginTime')"
        style="max-width: 100%;"
        :picker-options="startPickerOptions"
        @change="beginChange"
      />
    </div>
    <div class="time-range-picker-separator">
      <span>to</span>
    </div>
    <div class="time-range-picker end">
      <el-time-select
        v-model="inend"
        :placeholder="$l('form_placeholder_meetingEndTime')"
        style="max-width: 100%;"
        :picker-options="endPickerOptions"
        @change="endChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    begin: { type: String, default: '' },
    end: { type: String, default: '' },
  },
  data() {
    return { inbegin: '', inend: '' }
  },
  computed: {
    startPickerOptions() {
      const end = this.inend || '23:45'
      return { start: '00:00', step: '00:15', end }
    },
    endPickerOptions() {
      const start = this.inbegin || '00:00'
      return { start, step: '00:15', end: '24:00' }
    },
  },
  watch: {
    begin(val) {
      this.inbegin = val
    },
    end(val) {
      this.inend = val
    },
  },
  created() {
    this.inbegin = this.begin
    this.inend = this.end
  },
  methods: {
    beginChange(val) {
      this.$emit('update:begin', val)
    },
    endChange(val) {
      this.$emit('update:end', val)
    },
  },
}
</script>
<style lang="scss" scoped>
.time-range-picker-wrapper {
  display: flex;
  align-items: center;
  --separator-width: 28px;
  .time-range-picker {
    width: calc(calc(100% - var(--separator-width)) / 2);
  }
  .time-range-picker-separator {
    width: var(--separator-width);
    text-align: center;
  }
}

// ::v-deep {
//   .end .el-input__inner {
//     border-color: #dcdfe6 !important;
//   }
// }
</style>
